export const START_PHONE_VERIFY = 'START_PHONE_VERIFY';
export const STOP_OTP_REQUEST = 'STOP_OTP_REQUEST';
export const VERIFY_PHONE_SLIDER_UNMOUNT = 'VERIFY_PHONE_SLIDER_UNMOUNT';

export const POST_REQUEST_OTP = 'POST_REQUEST_OTP';
export const POST_REQUEST_OTP_SUCCESS = 'POST_REQUEST_OTP_SUCCESS';
export const POST_REQUEST_OTP_ERROR = 'POST_REQUEST_OTP_ERROR';

export const POST_VERIFY_OTP = 'POST_VERIFY_OTP';
export const POST_VERIFY_OTP_SUCCESS = 'POST_VERIFY_OTP_SUCCESS';
export const POST_VERIFY_OTP_ERROR = 'POST_VERIFY_OTP_ERROR';

export const ENABLE_RESEND_OTP = 'ENABLE_RESEND_OTP';
export const PHONE_VERIFY_CLEAR_CALLBACKS = 'PHONE_VERIFY_CLEAR_CALLBACKS';
